import { PARAMS, Routes } from "../utils/routes";

class NavigationService {
  /**
   * history object that can be used later for transfering between the pages
   * outside of components
   * Create a new method that uses the history object's method to utilize
   * this functionality
   */
  private history = null;

  public setHistory = (history: any) => {
    this.history = history;
  }

  public goToGameMoments = (gameId: string, openGeneralMomentId?: string) => {
    const params = new URLSearchParams();
    params.set(PARAMS.GAME_ID, gameId);
    if (openGeneralMomentId) {
      params.set(PARAMS.OPEN_GENERAL_MOMENT_ID, openGeneralMomentId);
    }
    this.history.push({
      pathname: Routes.MOMENT,
      search: params.toString(),
    });
  };

  /** In-app navigation from services (e.g. notification actions). */
  public push = (path: string): void => {
    if (this.history) {
      this.history.push(path);
    } else {
      window.location.assign(path);
    }
  };
}

export const NavigationServiceInstance = new NavigationService();
